import Vue from "vue";
import VueRouter from "vue-router";

import HelloWorld from "../page/HelloWorld";
import CMS from "../page/CMS";
import BusSupport from "../page/BusSupport";
import miniQrcode from "../page/miniUrl/miniQrcode";
import tips from "../page/miniUrl/tips";
import alipay from "../page/miniUrl/alipay";
import wechat from "../page/miniUrl/wechat";
import browser from "../page/miniUrl/browser";
import window from "../page/miniUrl/window";
import NcljlPromote from "../page/AlipayRedEnvelope/ncljlPromote";
import BlueSkySt from "../page/collectCustomerInfo/studentDriver/blueSkySt";

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    component: HelloWorld
  }, //没有任何路由时候,显示这个路由对应的组件
  {
    path: "/",
    name: "welcome",
    component: HelloWorld
  },
  {
    path: "/cms",
    name: "cms",
    component: CMS
  },
  {
    path: "/busSupport",
    name: "busSupport",
    component: BusSupport
  },
  {
    path: "/miniQrcode",
    name: "miniQrcode",
    component: miniQrcode
  },
  {
    path: "/tips",
    name: "tips",
    component: tips
  },
  {
    path: "/alipay",
    name: "alipay",
    component: alipay
  },
  {
    path: "/wechat",
    name: "wechat",
    component: wechat
  },
  {
    path: "/browser",
    name: "browser",
    component: browser
  },
  {
    path: "/window",
    name: "window",
    component: window
  },
  {
    path: "/ncljl",
    name: "ncljlPromote",
    component: NcljlPromote
  },
  {
    path: "/blueskySt",
    name: "BlueSkySt",
    component: BlueSkySt
  },
  {
    path: "/*",
    redirect: "/"
  } // 没有匹配到任何路由时,显示这个路由对应的组件
];

const router = new VueRouter({
  routes
});

export default router;



// WEBPACK FOOTER //
// ./src/router/router.js